import Css from "./style.module.scss";

import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import AutoTooltip from "nlib/ui/AutoTooltip";
import Money from "utils/Money";
import React from "react";
import TransactionAmount from "nlib/common/TransactionAmount";

const AmountCell = ({ transaction }) => {
  const { type, currency, amount, amountTotal } = transaction;

  const { uiTexts } = useSelector(getTextsData);

  return (
    <div className={Css.amountCell}>
      <div className={Css.split}>
        {!!amountTotal && uiTexts.split}
      </div>
      <div className={Css.amount}>
        <AutoTooltip>
          <TransactionAmount
            amount={amount}
            type={type}
            currency={currency} />
        </AutoTooltip>
      </div>
      <div className={Css.amountTotal}>
        {!!amountTotal && (
          <AutoTooltip>
            <span>{uiTexts.total}: </span>
            <span className={Css.total}>{Money.toMoneyString(amountTotal, currency)}</span>
          </AutoTooltip>
        )}
      </div>
    </div>
  );
};

export default React.memo(AmountCell);
